import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragHistoryListStatus: 'idle',
    loadAuftragHistoryListError: undefined as any,
    loadAuftragHistoryListLastArgs: undefined as any,

    auftragHistoryList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragHistoryList = createAsyncThunk('auftragHistorySlice/loadAuftragHistoryList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragHistorySlice.loadAuftragHistoryListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftraghist/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragHistoryListStatus } = getState().auftragHistorySlice
        return loadAuftragHistoryListStatus !== 'pending'
    }
})

const AuftragHistorySlice = createSlice({
    name: 'auftragHistorySlice',
    initialState,
    reducers: {
        resetloadAuftragHistoryListError: (state) => {
            state.loadAuftragHistoryListError = undefined
        },
        removeFromAuftragHistoryListById: (state, action) => {
            state.auftragHistoryList = state.auftragHistoryList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragHistoryListByIds: (state, action) => {
            state.auftragHistoryList = state.auftragHistoryList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragHistoryList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragHistoryListStatus = 'preloaded'
            state.loadAuftragHistoryListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragHistoryList = []
            state.loadAuftragHistoryListStatus = 'idle'
            state.loadAuftragHistoryListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragHistoryList.pending, (state) => {
            state.loadAuftragHistoryListStatus = 'pending'
            state.loadAuftragHistoryListError = undefined
        })
        builder.addCase(loadAuftragHistoryList.fulfilled, (state, action) => {
            state.loadAuftragHistoryListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragHistoryListLastArgs = action.payload.args

            {
                state.auftragHistoryList = action.payload.data

            }
        })
        builder.addCase(loadAuftragHistoryList.rejected, (state, action) => {
            state.loadAuftragHistoryListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragHistoryListError = action.error.message
            } else {
                state.loadAuftragHistoryListError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragHistoryListError,
    removeFromAuftragHistoryListById,
    removeFromAuftragHistoryListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragHistorySlice.actions
export default AuftragHistorySlice.reducer
